import React from 'react';
import {
    DataCollectionGapSummary
} from '../../../../store/Models/Api/DataCollectionGapSummaryModels';
import { useLocalizer } from '../hooks/useLocalizer';
import MaterialUnansweredQuestionsList from './MaterialUnansweredQuestionsList';
import SupplierLevelQuestionnaire from './SupplierLevelQuestionnaire';
import {
    hasMaterialGaps,
    hasQuestionnaireGaps
} from './helpers/gapSummaryHelpers';

interface QuestionSummarySectionProps {
    summaryPayload: DataCollectionGapSummary;
}

export const QuestionSummarySection: React.FC<QuestionSummarySectionProps> = ({
    summaryPayload
}) => {
    const localize = useLocalizer();
    const [isSupplierExpanded, setIsSupplierExpanded] = React.useState(false);
    const supplierQuestionnaireGaps = React.useMemo(() => {
        return summaryPayload.supplierQuestionnaires?.filter(hasQuestionnaireGaps) ?? [];
    }, [summaryPayload]);

    const materialGaps = React.useMemo(() => {
        return summaryPayload.materialData?.filter(hasMaterialGaps) ?? [];
    }, [summaryPayload]);

    const hasQuestionGaps = supplierQuestionnaireGaps.length > 0 || materialGaps.length > 0;

    return (
        <section className="gap-summary-section">
            <div className="gap-summary-section-header">
                <h4>{localize('Question Summary')}</h4>
            </div>
            <div className="gap-summary-question-summary-card">
                {!hasQuestionGaps && (
                    <div className="gap-summary-empty-state">
                        {localize('No required questions are unanswered.')}
                    </div>
                )}
                {hasQuestionGaps && (
                    <div className="gap-summary-question-list-panel">
                        <SupplierLevelQuestionnaire
                            supplierQuestionnaires={summaryPayload.supplierQuestionnaires ?? []}
                            isExpanded={isSupplierExpanded}
                            onToggle={() => setIsSupplierExpanded(isExpanded => !isExpanded)}
                        />
                        <MaterialUnansweredQuestionsList
                            materialGaps={materialGaps}
                        />
                    </div>
                )}
            </div>
            <p className="gap-summary-footer-note">
                {localize('The AI agent answers based only on the documents provided. You can request additional files from the supplier to iteratively fill remaining gaps.')}
            </p>
        </section>
    );
};

export default QuestionSummarySection;
